import { Check, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

// Native "dimension = column" switch (Keitaro-style): a small caret on the first
// column header flips the table's primary grouping between Domain and URL. It
// sits beside the sort label (which keeps sorting/filtering), so the two don't
// fight. Only shown for a single domain/url grouping; everything else goes
// through the full Group By control.

const OPTIONS: { value: "domain" | "url"; label: string }[] = [
  { value: "domain", label: "Domain" },
  { value: "url", label: "URL" },
];

export function PrimaryDimSwitch({
  value,
  onChange,
}: {
  value: string;
  onChange: (dim: string) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          title="Switch primary dimension (Domain / URL)"
          aria-label="Switch primary dimension"
          className="inline-flex size-5 shrink-0 cursor-pointer items-center justify-center rounded text-muted-foreground/60 hover:bg-muted hover:text-foreground"
        >
          <ChevronDown className="size-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-32">
        {OPTIONS.map((o) => (
          <DropdownMenuItem
            key={o.value}
            onSelect={() => onChange(o.value)}
            className="cursor-pointer gap-2"
          >
            <Check className={cn("size-3.5", value === o.value ? "opacity-100" : "opacity-0")} />
            {o.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
